import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {LeftDivComponent} from '../left-div/left-div.component';
import {LenderleftdivComponent} from '../lenderleftdiv/lenderleftdiv.component';
import {TimelineProgressBarComponent} from '../common/timeline-progress-bar/timeline-progress-bar.component';
import {LenderRegistrationProgressBarComponent} from './lender-registration-progress-bar/lender-registration-progress-bar.component';
import {BorrowerRegistrationProgressBarComponent} from './borrower-registration-progress-bar/borrower-registration-progress-bar.component';
import {UserInteractor} from '../interactors/user.interactor';
import {UserAddressInteractor} from '../interactors/user-address.interactor';
import {UserAddressService} from '../service/user-address.service';

@NgModule({
    imports: [CommonModule, RouterModule],
    exports: [LenderleftdivComponent, LeftDivComponent, TimelineProgressBarComponent, BorrowerRegistrationProgressBarComponent, LenderRegistrationProgressBarComponent],
    declarations: [LenderleftdivComponent, LeftDivComponent, TimelineProgressBarComponent, BorrowerRegistrationProgressBarComponent, LenderRegistrationProgressBarComponent],
    providers: [UserInteractor, UserAddressInteractor, UserAddressService]
})
export class LeftDivModule {
}
